import { render } from "./QAtaskDetails.vue?vue&type=template&id=2ae4bb92&scoped=true"
import script from "./QAtaskDetails.vue?vue&type=script&lang=js"
export * from "./QAtaskDetails.vue?vue&type=script&lang=js"

import "./QAtaskDetails.vue?vue&type=style&index=0&id=2ae4bb92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae4bb92"]])

export default __exports__